import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledFileUploaderContainer = styled.div`
    width: 100%;
    height: 100%;
`;

export const StyledUploadArea = styled.div<{ $error?: boolean }>`
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    padding: 16px;
    margin-bottom: 16px;
    border: 3px dashed;
    border-radius: var(--radius-5);
    border-color: ${(props) => (props.$error ? "var(--color-error)" : "var(--color-grey-700)")};
`;

export const StyledUploadAreaText = styled.div`
    font-size: var(--size-16);
    font-weight: normal;
    color: var(--color-grey-800);
    text-align: center;
    @media ${breakpoints.sm} {
        font-size: var(--size-12);
    }
`;

export const StyledChooseFileLabel = styled.span`
    color: var(--color-primary);
    text-decoration: underline;
    cursor: pointer;
`;
